"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8832],{

/***/ 8832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ TextAndIcons_TextAndIcons; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./theme/mixins/padding.ts
var padding = __webpack_require__(54986);
// EXTERNAL MODULE: ./components/Icons/Icon.tsx + 51 modules
var Icon = __webpack_require__(82218);
;// CONCATENATED MODULE: ./blocks/TextAndIcons/TextAndIcons.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 50%;\n  "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  max-width: 62.5rem;\n  margin: 0 auto;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    row-gap: 6rem;\n    grid-template-columns: repeat(3, 1fr);\n  "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  justify-items: center;\n  align-items: center;\n  row-gap: 3rem;\n  column-gap: 3rem;\n  max-width: 50rem;\n  margin: 0 auto;\n  width: 100%;\n\n  ",
        "\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: unset;\n  "
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 6rem;\n  ",
        "\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}





const Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6b980549-0"
})(_templateObject(), ()=>(0,padding/* blockPadV */.zr)({
        pt: "sm",
        pb: "sm"
    }), ()=>(0,padding/* blockPadH */.XA)());
const Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6b980549-1"
})(_templateObject1(), ()=>(0,padding/* blockW */.g5)());
const Lead = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-6b980549-2"
})(_templateObject3(), (param)=>{
    let { theme  } = param;
    return theme.gfx.mixins.mb(6);
}, (param)=>{
    let { theme  } = param;
    return theme.mq.xl(_templateObject2());
});
const IconsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6b980549-3"
})(_templateObject5(), (param)=>{
    let { theme  } = param;
    return theme.mq.md(_templateObject4());
});
const StyledIcon = (0,styled_components_browser_esm/* default */.ZP)(Icon/* default */.Z).withConfig({
    componentId: "sc-6b980549-4"
})(_templateObject7(), (param)=>{
    let { theme  } = param;
    return theme.mq.md(_templateObject6());
});
const TextAndIcons = (param)=>{
    let { lead  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Lead, {
                    children: lead
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconsContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIcon, {
                            name: "Mars",
                            color: "#FFF"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIcon, {
                            name: "K",
                            color: "#FFF"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIcon, {
                            name: "MiracleGro",
                            color: "#FFF"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIcon, {
                            name: "SpectrumHealth",
                            color: "#FFF"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIcon, {
                            name: "IBM",
                            color: "#FFF"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIcon, {
                            name: "Tovala",
                            color: "#FFF"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIcon, {
                            name: "Plume",
                            color: "#FFF"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIcon, {
                            name: "Starface",
                            color: "#FFF"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIcon, {
                            name: "Superplastic",
                            color: "#FFF"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var TextAndIcons_TextAndIcons = (TextAndIcons);

;// CONCATENATED MODULE: ./blocks/TextAndIcons/index.ts



/***/ })

}]);